import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { GlobalcfgService } from 'src/service/globalcfg.service';
import { HttpService } from 'src/service/http.service';
import Swal from 'sweetalert2';
import * as CryptoJS from "crypto-js";

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.css']
})
export class OtpComponent implements OnInit {

  model: any = {};
  tokenFromUI: string = "17eba9787a50e18b23d3";

  fieldTextType: boolean;
  isCollapsed = true;
  id: any;
  roleObj: any = [];


  constructor(
    private router: Router,
    private httpService: HttpService,
    private _Activatedroute: ActivatedRoute,
    private globalcfgService: GlobalcfgService,
    private authGuard: AuthGuard
  ) {
    this._Activatedroute.paramMap.subscribe(params => {
      this.id = params.get('id');
    });
    //this.authGuard.checkIdStatus();
  }

  ngOnInit(): void {
    const role = localStorage.getItem('roleName')
    //   if () {
    //     const firstLogin = JSON.parse(localStorage.getItem('firstLogin'));
    //     console.log(firstLogin);
    //     if (firstLogin == true) {
    //       this.router.navigate(['/change-password']);
    //     }
    //     this.companyProfileService.companyStatus();

    // }

    // if(Number(roleid) == 2){
    //   this.router.navigate(['challan-list'])
    // }
    // if(Number(roleid) == 9){
    //   this.router.navigate(['create-batch'])
    // }
    // else
    // {
    //   if(Number(roleid) == 4){
    //     this.router.navigate(['add-user'])
    //   } 
    // }
    if (role && role != null) {
      if(role == 'SUPER ADMIN'){
        this.router.navigate(['/super-admin/add-user']);

      }else if(role == 'DATA ENTRY OPERATOR'){
        this.router.navigate(['/data-entry-challan-list'])
      }else if(role === 'IMPORT IN-CHARGE'){
        this.router.navigate(['/importincharge'])
      }else if(role === 'SAMPLE ASSISTANT'){
        this.router.navigate(['/sample-assistant'])
      }
      else if(role === 'LAB RECEIVER'){
        this.router.navigate(['/lab-receiver'])
      }  else if(role === 'LAB ADMIN'){
        this.router.navigate(['/lab-admin'])
      }
      else if(role === 'LAB ANALYST'){
        this.router.navigate(['/lab-analyst'])
      } else if (role === 'LAB ACE'){
        this.router.navigate(['/lab-ace'])

      }
      else{
        this.router.navigate(['/verifier'])
      }
    }
  }

  onSignIn(form: NgForm) {
    if (form.valid) {
      if (localStorage.getItem('otp_status') == 'forgot') {
        let ciphertext = CryptoJS.AES.encrypt(form.value.username.toString(), this.tokenFromUI).toString();
        var otp_validate_Obj = {
          email: localStorage.getItem('email'),
          otp_tokenId: localStorage.getItem('token'),
          otp: ciphertext
        }
        this.httpService.forgotPasswordOTPVerify(otp_validate_Obj).subscribe(result => {
         // console.log(result)
          localStorage.setItem('uuid',result.responseData[1][0].user_id);
          localStorage.setItem('authToken' , result.responseData[1][0].token)

          if (result.responseCode == 0) {
            if (this.id == 1) {
              this.router.navigate(['reset-password']);
            }
            else {
              this.rolesFull();
            }
          }
          else {
            Swal.fire({
              html: `<h6 class="head">Error!<h6><h5 class="sub-head">invalid OTP</h5>`,

              icon: 'error',
              confirmButtonText: 'OK',
              customClass: {
                container: 'my-swal',
                confirmButton: 'your-confirm-button-class',

              }
            }).then((result) => {
            });
          }
        }, err => {
          console.log(err)
        })
      }
      else{
        let email=localStorage.getItem('email');
        let token=localStorage.getItem('token');
        let ciphertext = CryptoJS.AES.encrypt(form.value.username.toString(), this.tokenFromUI).toString();
        
        var otpObj={
          email:email,
          otp_tokenId:token,
          otp:ciphertext
        }
        this.httpService.validateOTP(otpObj).subscribe(result => {

          if (result.responseCode == 0) {
            // debugger
            // this.httpService.IPWhitelist({
            //   "_ip": '202.153.43.189',
            //   "_userId": result.responseData[1][0].user_id}).subscribe(ip => {
            //       if(ip && ip.responseCode === 0){

                    localStorage.setItem('userData',JSON.stringify(result.responseData[1][0]));
            
                    localStorage.setItem('roleid',result.responseData[1][0].role_id);
                    const roleObj = {
                      organisation_id:result.responseData[1][0].organisation_id
                    }
                
                    localStorage.setItem('roleName',result.responseData[1][0].role_name)
                    localStorage.setItem('location',result.responseData[1][0].location)
                    localStorage.setItem('uuid',result.responseData[1][0].user_id);
                    localStorage.setItem('orgid',result.responseData[1][0].organisation_id);
                    localStorage.setItem('username',result.responseData[1][0].first_name[0].charAt(0).toUpperCase() + result.responseData[1][0].first_name[0].slice(1) + ' ' + result.responseData[1][0].last_name[0].charAt(0).toUpperCase() + result.responseData[1][0].last_name[0].slice(1));
                 
                    if(this.id == 1){
                      this.router.navigate(['reset-password']);
                    }
                    else {
                      this.rolesFull();
                    }

                  // }else {
                  //   this.router.navigate(['/access-restriction']);

                  // }
                
                // });
            
           
          }
          else {
            Swal.fire({
              html: `<h6 class="head">Error!<h6><h5 class="sub-head">invalid OTP</h5>`,

              icon: 'error',
              confirmButtonText: 'Ok',
              customClass: {
                container: 'my-swal',
                confirmButton: 'your-confirm-button-class',

              }
            }).then((result) => {
            });
          }
        }, err => {
          console.log(err)
          //alert(err.error.message);

          Swal.fire({
            html: `<h6 class="head">Error!<h6><h5 class="sub-head">Invalid OTP</h5>`,

            icon: 'error',
            confirmButtonText: 'OK',
            customClass: {
              container: 'my-swal',
              confirmButton: 'your-confirm-button-class',

            }
          }).then((result) => {
          });
        })
      }

    }
  }
  getIPRestricStatus(){
   

      this.httpService.IPWhitelist({
      "_ip": localStorage.getItem('IP'),
      "_userId": localStorage.getItem("uuid")}).subscribe(result => {
          if(result && result.responseCode === 0){
             localStorage.setItem('isIP' , 'yes')
          } else {
            localStorage.setItem('isIP' , 'no')
          }

  
  })

  }
  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }
  goToSignUp() {
    this.router.navigate(['/'])
  }
  rolesFull() {
    var roleid = localStorage.getItem('roleid');
    var roleName = localStorage.getItem('roleName');

    
    var uid = localStorage.getItem('uuid');
    const userObj = {
      "role_id": roleid,
      "user_id": uid
    }
    
    // this.httpService.roleList(userObj).subscribe((response) => {
    //   this.roleObj = response.data;
    //   this.globalcfgService.setFullRoleObj(this.roleObj);
    //   var x = this.globalcfgService.getFullRoleObj();
     if(roleName == 'DATA ENTRY OPERATOR'){
      this.router.navigate(['/data-entry-challan-list'])
    }
      if (roleName === 'VERIFIER' ) {
        this.router.navigate(['verifier']); 

      }
      if (roleName === 'VERIFIER' ) {
        this.router.navigate(['verifier']); 

      }
     
      if (roleName === 'IMPORT IN-CHARGE') {
        this.router.navigate(['importincharge'])
        localStorage.setItem('isDeactive' , 'true');

      }
      if (roleName === 'SAMPLE ASSISTANT' ) {
        this.router.navigate(['sample-assistant'])
        localStorage.setItem('isDeactive' , 'true');

      }
      if (roleName === 'LAB RECEIVER' ) {
        this.router.navigate(['lab-receiver'])
        localStorage.setItem('isDeactive' , 'true');

      }
      if(roleName === 'LAB ADMIN' ){
        this.router.navigate(['/lab-admin'])

      }
      if(roleName ===  'LAB ANALYST'){
        this.router.navigate(['/lab-analyst'])

      }
      if(roleName === 'LAB ACE'){
        this.router.navigate(['/lab-ace'])

      }

      if(roleName === 'ASSISTANT IMPORT IN-CHARGE'){
        this.router.navigate(['/ass-Import-Incharge'])

      }
      else {
        if (roleName === 'SUPER ADMIN') {
          this.router.navigate(['/super-admin/add-user'])
          localStorage.setItem('isDeactive' , 'true');

        }
      }

    // }, error => {
    //   console.log(error)
    // });
  }

}